import React from 'react';
import * as styles from './styles.module.scss';

import PartnerLink from './components/PartnerLink';

const PartnerLinks = ({ curPartner, onPartnerClick, partners }) => (
  <div className={styles.wrap}>
    <ul className={styles.links}>
      {partners.map((partner) => (
        <li key={partner.id}>
          <PartnerLink
            img={partner.logo}
            isActive={curPartner.id === partner.id}
            onClick={() => {
              onPartnerClick(partner);
            }}
          />
        </li>
      ))}
    </ul>
  </div>
);

export default PartnerLinks;
